import { AppColors } from "@/assets/colors";

export const aboutSections = [
  {
    id: "mission",
    number: "01",
    title: "Our Mission",
    content:
      "To redefine real estate by delivering innovative, sustainable, and high-quality properties that enhance communities, foster growth, and create long-term value for homeowners and investors. Through a commitment to excellence and customer-centric solutions, we make real estate investment seamless, and rewarding.",
    image: "/images/about/mission-image.svg",
    bg: `${AppColors.primary["500"]}`,
  },
  {
    id: "vision",
    number: "02",
    title: "Our Vision",
    content:
      "To become a premier real estate brand recognized for integrity, innovation, and customer satisfaction. We strive to set new industry standards by providing exceptional living and investment opportunities while fostering lasting relationships built on trust and transparency",
    image: "/images/about/vision-image.png",
    bg: `${AppColors.gradient.mission}`,
  },
  {
    id: "values",
    number: "03",
    title: "Our Core Values",
    content: `Integrity & Transparency – We uphold honesty in every transaction.
          Innovation & Excellence – We adopt modern solutions for top-tier properties.
          Customer Satisfaction – We prioritize our clients' needs at every step.
          Sustainability & Growth – We build for the future with eco-friendly practices.`,
    image: "/images/about/core-values.png",
    bg: `${AppColors.secondary["500"]}`,
  },
];
